import { MAX_NUM_BRAND_SUGGESTIONS_CONFIG } from "@faire/web-api--source/indigofair/settings/MAX_NUM_BRAND_SUGGESTIONS_CONFIG";

import { MAX_DESKTOP_SUGGESTION_BRANDS } from "@faire/retailer/components/TopSearch/ResultDropdown/consts";
import { getSettingValueWithoutAssignment } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";

export const getSettingMaxNumBrandSuggestionsConfig = () =>
  getSettingValueWithoutAssignment(
    MAX_NUM_BRAND_SUGGESTIONS_CONFIG,
    MAX_DESKTOP_SUGGESTION_BRANDS
  );
